import { useMemo, useState } from 'react';

export const useTableFilter = ({
  onFilterChange,
}: {
  onFilterChange: (values: Record<string, any>) => void;
}) => {
  const [siderVisible, setSiderVisible] = useState(false);
  const [filterState, setFilterState] = useState<Record<string, any>>({});

  const filterCount = useMemo(
    () => Object.values(filterState).filter((value) => value !== undefined && value !== '').length,
    [filterState],
  );

  const showSider = () => setSiderVisible(true);

  const hideSider = () => setSiderVisible(false);

  const onSubmit = (values: Record<string, any>) => {
    setFilterState(values);
    onFilterChange(values);
  };

  return {
    state: {
      siderVisible,
      filterState,
      filterCount,
    },
    methods: {
      showSider,
      hideSider,
      onSubmit,
    },
  };
};
